export const BOOKSY_NOTIFICATION_TYPE = 'booksy_notification' as const

export const BOOKSY_NOTIFICATION_EVENT_ACTIONS = {
  RECEIVED: 'received',
  CLICKED: 'clicked',
} as const
